<script>
	import Helper from '../Models/Helper';
	import Basket from './Product/Basket.svelte';
	import Groups from './Product/Groups.svelte';
	import Info from './Product/Info.svelte';
	import Options from './Product/Options.svelte';
	import Product from '../States/Product';

	let groups = true;
	let options = false;
	let basket = false;
	let info = false;

	Product.subscribe(product => {
		groups = !product.basket && !product.options && !product.info;
		options = !product.basket && !product.info && product.options;
		basket = !product.info && product.basket;
		info = !product.basket && product.info;
	});
</script>

<style>
	div.phd-box {
		position: absolute;
		background-color: var(--phd-background-primary);
		top: 0; right: -1px; bottom: 0; left: -1px;
		transition: transform 3s cubic-bezier(0, .99, .6, .99), opacity 3s ease-out;
		will-change: transform, opacity;
		backface-visibility: hidden;
		z-index: 15;
		opacity: 0;
	}

	div.phd-box.phd-product-groups {
		transform: translateX(-100%);
	}

	div.phd-box.phd-product-options {
		transform: translateX(100%);
	}

	div.phd-box.phd-product-basket {
		transform: translateX(100%);
	}

	div.phd-box.phd-product-info {
		transform: translateX(100%);
	}

	div.phd-box.phd-front {
		transform: translateX(0);
		transition-duration: .4s;
		opacity: 1;
		z-index: 20;
	}
</style>

<div class="phd-box phd-product-groups" class:phd-front="{groups}">
	<Groups/>
</div>
<div class="phd-box phd-product-options" class:phd-front="{options}">
	<Options/>
</div>
<div class="phd-box phd-product-basket" class:phd-front="{basket}">
	<Basket/>
</div>
<div class="phd-box phd-product-info" class:phd-front="{info}">
	<Info/>
</div>
